import React from "react";
import { useT } from "@/lib/i18n";

const COLORS = {
  angelegt:              { color: "#4B5563", bg: "#E5E7EB" },
  briefing_versendet:    { color: "#0E62C4", bg: "#E4EEFB" },
  in_arbeit:             { color: "#0E62C4", bg: "#E4EEFB" },
  wartet_auf_freigabe:   { color: "#8A5A00", bg: "#FBEED8" },
  in_abstimmung:         { color: "#8A5A00", bg: "#FBEED8" },
  pausiert:              { color: "#6B4A00", bg: "#F3E5C7" },
  abgeschlossen:         { color: "#157A4A", bg: "#DDEEE3" },
  abgerechnet:           { color: "#1B1E23", bg: "#E5E4DE" },
  storniert:             { color: "#BE2E6C", bg: "#F7DDE7" },
};

export default function StatusPill({ status }) {
  const t = useT();
  const s = COLORS[status] || { color: "#1B1E23", bg: "#E5E4DE" };
  const label = t(`status.${status}`);
  return (
    <span
      className="status-pill"
      style={{ color: s.color, backgroundColor: s.bg, borderColor: `${s.color}22` }}
      data-testid={`status-pill-${status}`}
    >
      {label === `status.${status}` ? status : label}
    </span>
  );
}
